import logicMixin from './mixins/logic'
import renderMixin from './mixins/render'

export { logicMixin, renderMixin }
export default {
  logicMixin,
  renderMixin
}
